export const policiesNIE = [];

export const policiesNIC = [
  {
    link: '/nomad-insurance/complete/standard_nomad_insurance_complete_vumi+carrier_2025-04.pdf',
    name: 'Standard Nomad Insurance Complete VUMI+Carrier (04/2025)'
  },
  {
    link: '/nomad-insurance/complete/premium_nomad_insurance_complete_vumi+carrier_2025-04.pdf',
    name: 'Premium Nomad Insurance Complete VUMI+Carrier (04/2025)'
  },
  {
    link: '/nomad-insurance/complete/premium_plus_nomad_insurance_complete_vumi+carrier_2025-04.pdf',
    name: 'Premium Plus Nomad Insurance Complete VUMI+Carrier (04/2025)'
  }
];

export const policiesNH = [
  {
    link: '/nomad-health/policies/nomad-health-premium-plus-plan-5.0.pdf',
    name: 'Premium Plus Nomad Health VUMI (04/2025)'
  },
  {
    link: '/nomad-health/policies/nomad-health-premium-plan-5.0.pdf',
    name: 'Premium Nomad Health VUMI (04/2025)'
  },
  {
    link: '/nomad-health/policies/nomad-health-standard-plan-5.0.pdf',
    name: 'Standard Nomad Health VUMI (04/2025)'
  }
];

export const policiesCommunityRH = [
  {
    link: '/remote-health/policy-documents/v4/premium-plus-community-plan-4-0V2025-04-15.pdf',
    name: 'Premium Plus Community VUMI (04/2025)',
    effectiveDate: '2025-04-15'
  },
  {
    link: '/remote-health/policy-documents/v4/premium-community-plan-4-0V2025-04-15.pdf',
    name: 'Premium Community VUMI (04/2025)',
    effectiveDate: '2025-04-15'
  },
  {
    link: '/remote-health/policy-documents/v4/standard-community-plan-4-0V2025-04-15.pdf',
    name: 'Standard Community VUMI (04/2025)',
    effectiveDate: '2025-04-15'
  },
  {
    link: '/remote-health/policy-documents/v4/essential-community-plan-4-0V2025-04-15.pdf',
    name: 'Essential Community VUMI (04/2025)',
    effectiveDate: '2025-04-15'
  }
];

export const policiesIndividualsRH = [
  {
    link: '/remote-health/policy-documents/v4/premium-plus-individuals-4-0-plan-2025-04.pdf',
    name: 'Premium Plus Individual VUMI (04/2025)',
    effectiveDate: '2025-04-15'
  },
  {
    link: '/remote-health/policy-documents/v4/premium-individuals-4-0-plan-2025-04.pdf',
    name: 'Premium Individual VUMI (04/2025)',
    effectiveDate: '2025-04-15'
  },
  {
    link: '/remote-health/policy-documents/v4/standard-individuals-4-0-plan-2025-04.pdf',
    name: 'Standard Individual VUMI (04/2025)',
    effectiveDate: '2025-04-15'
  }
  // {
  //   //TODO: MISSING DOC!
  //   link: '/remote-health/policy-documents/v4/essential-individuals-4-0-plan-2025-04.pdf',
  //   name: 'Essential Individual VUMI (04/2025)',
  //   effectiveDate: '2025-04-15'
  // }
];

export const archiveNI = [
  {
    link: '/nomad-insurance/policy?version=2024-02-21',
    name: 'Deductible $0 Carrier - Dynamic (02/2024)'
  },
  {
    link: 'https://assets.ctfassets.net/hal1sayc3tet/1mD3gNSSFgB8ioMMzaE5ex/1797def2f58b956bff6902758a3c558a/SWIII-DOC-002__02.24_.pdf',
    name: 'Deductible $0 Carrier - PDF (02/2024)'
  },
  {
    link: '/nomad-insurance/policy?version=2023-09-19',
    name: 'Deductible $250 Carrier - Dynamic (09/2023)'
  },
  {
    link: 'https://assets.ctfassets.net/hal1sayc3tet/7iIzO8oC3D119GD9THMxrF/8e344f120c8d9d20306ed1298b6ef7bd/SWIII-DOC-001__09.23_.pdf',
    name: 'Deductible $250 Carrier - PDF (09/2023)'
  },
  {
    link: '/nomad-insurance/description-of-coverage.pdf',
    name: 'Old policy WorldTrips (02/2023)',
    effectiveDate: '2023-02-01'
  },
  {
    link: '/nomad-insurance/description-of-coverage-2022-4.pdf',
    name: 'Old policy WorldTrips (04/2022)',
    effectiveDate: '2022-04-01'
  },
  {
    link: '/nomad-insurance/description-of-coverage-2020-8.pdf',
    name: 'Old policy Tokio Marine (08/2020)',
    effectiveDate: '2020-08-01'
  },
  {
    link: '/nomad-insurance/description-of-coverage-2020-4.pdf',
    name: 'Old policy Tokio Marine (04/2020)',
    effectiveDate: '2020-04-01'
  },
  {
    link: '/nomad-insurance/description-of-coverage-2019-2.pdf',
    name: 'Old policy Tokio Marine (09/2019)',
    effectiveDate: '2019-09-01'
  },
  {
    link: '/nomad-insurance/safety-wing-specimen-policy.pdf',
    name: 'Old policy Tokio Marine (01/2019)',
    effectiveDate: '2019-01-01'
  },
  {
    link: '/nomad-insurance/safety-wing-specimen-policy-2018.pdf',
    name: 'Original policy Tokio Marine (01/2018)',
    effectiveDate: '2018-01-01'
  }
];

export const archiveNH = [
  {
    link: '/nomad-health/policies/nomad-health-premium-plus-maternity-plan-4.0.pdf',
    name: 'Premium Plus Nomad Health VUMI (08/2024)'
  },
  {
    link: '/nomad-health/policies/nomad-health-premium-plan-4.0.pdf',
    name: 'Premium Nomad Health VUMI (08/2024)'
  },
  {
    link: '/nomad-health/policies/nomad-health-standard-plan-4.0.pdf',
    name: 'Standard Nomad Health VUMI (08/2024)'
  },
  {
    link: '/remote-health/policy-documents/v3/nomad-health-premium-plus-plan-3.0.pdf',
    name: 'Premium Plus Nomad Health VUMI (12/2023)'
  },
  {
    link: '/remote-health/policy-documents/v3/nomad-health-premium-plan-3.0.pdf',
    name: 'Premium Nomad Health VUMI (12/2023)'
  },
  {
    link: '/remote-health/policy-documents/v3/nomad-health-standard-plan-3.0.pdf',
    name: 'Standard Nomad Health VUMI (12/2023)'
  },
  {
    link: '/nomad-health/policies/nomad-health-premium+maternity-plan.pdf',
    name: 'Premium Plus Nomad Health VUMI (07/2023)',
    effectiveDate: '2023-07-01'
  },
  {
    link: '/nomad-health/policies/nomad-health-premium-plan.pdf',
    name: 'Premium Nomad Health VUMI (07/2023)',
    effectiveDate: '2023-07-01'
  },
  {
    link: '/nomad-health/policies/nomad-health-standard-plan.pdf',
    name: 'Standard Nomad Health VUMI (07/2023)',
    effectiveDate: '2023-07-01'
  },
  {
    link: '/remote-health/premium-plus-nomad-2.0.pdf',
    name: 'Vumi Premium Plus Nomad Plan (07/2023)'
  },
  {
    link: '/remote-health/premium-individual-plan-2.0.pdf',
    name: 'Vumi Premium Individual Plan (12/2022)'
  },
  {
    link: '/remote-health/standard-individual-plan-2.0.pdf',
    name: 'Vumi Standard Individual Plan (12/2022)'
  },
  {
    link: '/nomad-health/MemberHandbook.pdf',
    name: 'Original policy (01/2020)'
  }
];

export const archiveCommunityRH = [
  {
    link: '/remote-health/policy-documents/v3/premium-plus-community-plan-3-0V2023-12-15.pdf',
    name: 'Premium Plus Community VUMI (12/2023)',
    effectiveDate: '2023-12-15'
  },
  {
    link: '/remote-health/policy-documents/v3/premium-community-plan-3-0V2023-12-15.pdf',
    name: 'Premium Community VUMI (12/2023)',
    effectiveDate: '2023-12-15'
  },
  {
    link: '/remote-health/policy-documents/v3/standard-community-plan-3-0V2023-12-15.pdf',
    name: 'Standard Community VUMI (12/2023)',
    effectiveDate: '2023-12-15'
  },
  {
    link: '/remote-health/policy-documents/v3/essential-community-plan-3-0V2023-12-15.pdf',
    name: 'Essential Community VUMI (12/2023)'
  },
  {
    link: '/remote-health/policy-documents/v3/premium-plus-community-plan-2024-04.pdf',
    name: 'Premium Plus Community VUMI (04/2024)',
    effectiveDate: '2024-04-15'
  },
  {
    link: '/remote-health/policy-documents/v3/premium-community-plan-2024-04.pdf',
    name: 'Premium Community VUMI (04/2024)',
    effectiveDate: '2024-04-15'
  },
  {
    link: '/remote-health/policy-documents/v3/standard-community-plan-2024-04.pdf',
    name: 'Standard Community VUMI (04/2024)',
    effectiveDate: '2024-04-15'
  },
  {
    link: '/remote-health/policy-documents/v3/essential-community-plan-2024-04.pdf',
    name: 'Essential Community VUMI (04/2024)',
    effectiveDate: '2024-04-15'
  },
  {
    link: '/remote-health/premium-plus-community-2.0-PR.pdf',
    name: 'Premium Plus Community VUMI PR (07/2023)'
  },
  {
    link: '/remote-health/premium-plus-community-2.0-T&C.pdf',
    name: 'Premium Plus Community VUMI T&C (07/2023)'
  },
  {
    link: '/remote-health/premium+maternity-community-plan-2.0-PR.pdf',
    name: 'Premium Plus Community VUMI PR (04/2023)'
  },
  {
    link: '/remote-health/premium-community-plan-2.0-PR.pdf',
    name: 'Premium Community VUMI PR (04/2023)'
  },
  {
    link: '/remote-health/standard-community-plan-2.0-PR.pdf',
    name: 'Standard Community VUMI PR (04/2023)'
  },
  {
    link: '/remote-health/premium+maternity-community-plan-2.0-T&C.pdf',
    name: 'Premium Plus Community VUMI T&C (04/2023)'
  },
  {
    link: '/remote-health/premium-community-plan-2.0-T&C.pdf',
    name: 'Premium Community VUMI T&C (04/2023)'
  },
  {
    link: '/remote-health/standard-community-plan-2.0-T&C.pdf',
    name: 'Standard Community VUMI T&C (04/2023)'
  },
  {
    link: '/remote-health/premium+maternity-community-plan-2.0.pdf',
    name: 'Premium Plus Community VUMI (05/2022)'
  },
  {
    link: '/remote-health/premium-community-plan-2.0.pdf',
    name: 'Premium Community VUMI (05/2022)'
  },
  {
    link: '/remote-health/standard-community-plan-2.0.pdf',
    name: 'Standard Community VUMI (05/2022)'
  },
  {
    link: '/remote-health/premium-community-plan-1.5.pdf',
    name: 'Vumi Premium Community Plan 1.5'
  },
  {
    link: '/remote-health/standard-community-plan-1.5.pdf',
    name: 'Vumi Standard Community Plan 1.5'
  },
  {
    link: '/remote-health/MemberHandbook-Vumi-V2.pdf',
    name: 'Vumi 1.5 (08/2021)'
  },
  {
    link: '/remote-health/MemberHandbook-Vumi-V1.pdf',
    name: 'VUMI 1.0 (04/2021)'
  },
  {
    link: '/remote-health/MemberHandbook-04-2021.pdf',
    name: 'Updated policy NOW Health (04/2021)'
  },
  {
    link: '/remote-health/MemberHandbook.pdf',
    name: 'Original policy NOW Health (01/2020)'
  }
];

export const archiveAffinityRH = [
  {
    link: '/remote-health/policy-documents/v3/premium_plus-affinity-3-0-plan-2024-04.pdf',
    name: 'Premium Plus Affinity VUMI (04/2024)'
  },
  {
    link: '/remote-health/policy-documents/v3/premium-affinity-3-0-plan-2024-04.pdf',
    name: 'Premium Affinity VUMI (04/2024)'
  },
  {
    link: '/remote-health/policy-documents/v3/standard-affinity-3-0-plan-2024-04.pdf',
    name: 'Standard Affinity VUMI (04/2024)'
  },
  {
    link: '/remote-health/policy-documents/v3/essential-affinity-3-0-plan-2024-04.pdf',
    name: 'Essential Affinity VUMI (04/2024)'
  },
  {
    link: '/remote-health/premium-plus-affinity-2.0.pdf',
    name: 'Premium Plus Affinity VUMI (07/2023)'
  },
  {
    link: '/remote-health/premium+maternity-affinity-plan-2.0.pdf',
    name: 'Premium Affinity VUMI (09/2022)'
  },
  {
    link: '/remote-health/premium-affinity-plan-2.0.pdf',
    name: 'Standard Affinity VUMI (09/2022)'
  },
  {
    link: '/remote-health/standard-affinity-plan-2.0.pdf',
    name: 'Essential Affinity VUMI (09/2022)'
  },
  {
    link: '/nomad-health/Deel-Policy-document.pdf',
    name: 'Vumi DEEL Affinity Plan'
  }
];

export const archiveIndividualsRH = [];

export const archiveNIC = [
  {
    link: '/nomad-insurance/complete/standard_nomad_insurance_complete_vumi+carrier_2024-12.pdf',
    name: 'Standard Nomad Insurance Complete VUMI+Carrier (12/2024)'
  }
];
